<template>
  <v-app-bar color="primary" prominent>
    <v-app-bar-nav-icon v-if="isLogin" variant="text" @click.stop="drawer = !drawer" />
    <v-spacer />

    <v-toolbar-title  v-if="isLogin" class="ml-n6">{{ store.clinic.name }}</v-toolbar-title>

    <SwSessionMenu v-if="isLogin" />
  </v-app-bar>

  <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer" />

  <v-navigation-drawer v-model="drawer" temporary>
    <AppMenu v-if="isLogin"/>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { swStore } from "sw-gw-gui";

export default defineComponent({
  data: () => ({
    drawer: false,
    store: swStore(),
  }),

  computed: {
    isLogin() {
      return this.store.user.user_id != '';
    },
  },
});
</script>
